/**
 * Exhaustiveness guard for switch statements over closed string unions.
 * TypeScript rejects `value` at every call site unless every union member
 * has already been handled by a preceding `case` — so adding a new member
 * to the union without adding its `case` is a compile error here, not a
 * silent runtime fall-through.
 */
export function assertNever(value: never): never {
  throw new Error(`Unhandled case: ${JSON.stringify(value)}`);
}
